//View Form Data
const commonViewField = [
    {label: "Class", type: "string", value_key: "class_name"},
    {label: "Level", type: "string", value_key: "level_name"},
    {label: "IFSPD Program", type: "string", value_key: "program_name"},
    {label: "Session/Role/Award",
        type: "table",
        value_key: "glosco_data",
        header: ["Session", "Role", "Award"],
        columns: [
            {type: "string", fetch_key: "session_name"},
            {type: "string", fetch_key: "role"},
            {type: "comma_string", fetch_key: "award_data", display_key: "award_name"}
        ]
    }
];
const fieldGloscoReqView = [
    {label: "User Id", type: "string", value_key: "user_id"},
    {label: "School", type: "string", value_key: "school_name"},
    {label: "Branch", type: "string", value_key: "branch_name"},
    ...commonViewField
];

const fieldGloscoReqCompactView = [
    {label: "User Id", type: "string", value_key: "user_id"},
    ...commonViewField
];

const data = {
    fieldGloscoReqView,
    fieldGloscoReqCompactView
};

export default data;